export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8685.7d2cc0f8.jpg";